import {Route, Routes} from "react-router-dom";

import {App} from "./App.jsx";
import {MenuLayout} from "./layouts/MenuLayout/MenuLayout.jsx";

import {UserPreferences} from "./pages/settings/UserPreferences/UserPreferences.jsx";
import {FullPage} from "@/pages/FullPage/FullPage.jsx";
import {properties} from "@/properties.js";
import {NoPermissionModal} from "@/components/custom/NoPermissionModal/NoPermissionModal.jsx";

export const IHRouter = () => {
	function handleGoToLanding() {
		window.location.href = properties.landingUrl;
	}

	return (
		<div data-testid="router-root">
			<NoPermissionModal requiredApi="inventory-api" onGoToLanding={handleGoToLanding} />
			<Routes>
				<Route path="/data" element={<FullPage />} />

				<Route path="/settings" element={<MenuLayout />} data-testid="router-settings">
					<Route
						path="user-preferences"
						element={<UserPreferences />}
						data-testid="router-user-preferences"
					/>
				</Route>

				<Route path="/*" element={<App />} />
			</Routes>
		</div>
	);
};
